import {parseComponentScreenId} from '@features/flow/utils/componentScreenId';
import {useRecompile} from '@features/flow/utils/useRecompile';
import {setSyncStatus} from '@features/frame/partialEdit/syncStatusAtom';
import {trpc} from '@features/utils/trpc';
import {toast} from 'sonner';

export function useComponentUpdateText() {
  const {mutateAsync: recompile} = useRecompile();

  const {mutate, mutateAsync, ...args} =
    trpc.screens.changeComponentScreenText.useMutation({
      async onSuccess(_, {screenId}) {
        const {success} = await recompile(parseComponentScreenId(screenId));
        if (success) {
          setSyncStatus('success');
        } else {
          setSyncStatus('idle');
          toast.error('We had some issues saving your changes!');
        }
      },
      onError: () => {
        setSyncStatus('idle');
      },
    });

  return {
    updateComponentText: mutate,
    updateComponentTextAsync: mutateAsync,
    ...args,
  };
}
